/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-12 16:10.
 */
const Server = require( 'helper/server' );
const Regexp = require( 'helper/regexp' );
const secuntry = require( 'helper/secuntry' );

const modifyPassword = Handlebars.templates[ 'purchasing-federation/member-info/templates/modifypassword' ];

const ModifyPassword = {
  async init() {
    const html = modifyPassword();
    this.$el.find( '.info-wrap' ).html( html );
  },
  async commitPasswodr() {
    const password = this.$el.find( '.password' ).val();
    const passwordNew = this.$el.find( '.passwordNew' ).val();
    const passwordConfirm = this.$el.find( '.passwordConfirm' ).val();
    let errMsg = undefined;
    if (!password && !errMsg) {
      errMsg = '请输入原始密码';
    }
    if (!passwordNew && !errMsg) {
      errMsg = '请输入新密码';
    }
    if (!passwordConfirm && !errMsg) {
      errMsg = '请确认密码';
    }
    if (password === passwordNew && !errMsg) {
      errMsg = '修改后的密码不能和原密码相同';
    }
    if (!Regexp.passward.test( passwordNew ) && !errMsg) {
      errMsg = '密码不合规，需为6-20个字母、数字、字符，至少含2种';
    }
    if (passwordConfirm !== passwordNew && !errMsg) {
      errMsg = '两次输入的密码不一致，请重新输入';
    }
    if (errMsg) {
      ZCY.utils.modal( {
        type: 'error',
        cls: 'as-modal',
        button: [ '确定' ],
        container: $( '.modifypassword' ),
        content: [ errMsg ]
      } );
      return false;
    }
    const spiner = this.$el.find( '.block__content' ).spin();
    let res = undefined;
    try {
      res = await Server.commitPasswordModify( {
        password: secuntry.encode( password ),
        passwordNew: secuntry.encode( passwordNew ),
        passwordConfirm: secuntry.encode( passwordConfirm )
      } );
      this.$el.find( '.password' ).val( undefined );
      this.$el.find( '.passwordNew' ).val( undefined );
      this.$el.find( '.passwordConfirm' ).val( undefined );
    }
    catch ( e ) {
      res = e.responseText || '未知错误';
    }
    spiner.stop();
    ZCY.utils.modal( {
      type: res == true ? 'success' : 'error',
      cls: 'as-modal modify-password',
      button: [ '确定' ],
      container: $( '.modifypassword' ),
      content: [ res == true ? '修改成功，请重新登录' : res ],
      confirm: ( $modal ) => {
        $modal.modal( 'hide' );
        window.location.href = '/home.html';
        if (res === true) {
          Server.purchaseLogout().then( () => {
            $( 'body' ).find( '.logined, .loginedwrap' ).hide();
            $( 'body' ).find( '.unlogin, .unloginwrap' ).show();
          } );
        }
      }
    } );
  },
  closeModal() {
    Server.purchaseLogout().then( () => {
      window.location.href = '/home.html';
    } );
  }
};

module.exports = ModifyPassword;
